import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.small";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.small";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.symbol";

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import styled from 'styled-components';
import Flag from '../Flag';
import { typography, spacing } from '../../style/theme';
import { getFontSize } from '../../utils/helpers';
var FlushText = styled.p.withConfig({
  displayName: "Quote__FlushText",
  componentId: "oen64b-0"
})(["margin-bottom:0;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.color || null;
});
var Quote = styled.p.withConfig({
  displayName: "Quote",
  componentId: "oen64b-1"
})(["", " color:", ";@media only screen and (max-width:", "px){font-size:", "rem;line-height:2.4rem;}"], getFontSize(typography.medium), function (_ref2) {
  var theme = _ref2.theme;
  return theme.color || null;
}, spacing.collapseMenuWidth, typography.small);

var USPQuote = function USPQuote(_ref) {
  var image = _ref.image,
      person = _ref.person,
      text = _ref.text,
      props = _objectWithoutProperties(_ref, ["image", "person", "text"]);

  return React.createElement("div", props, text && React.createElement(Quote, null, "\"", text, "\""), image && person && React.createElement(Flag, {
    image: image
  }, React.createElement(FlushText, null, person.name), React.createElement(FlushText, null, React.createElement("strong", null, person.company))));
};

export default USPQuote;